import { render, staticRenderFns } from "./AmpAuth.vue?vue&type=template&id=a8c2b6f4&scoped=true&"
import script from "./AmpAuth.vue?vue&type=script&lang=js&"
export * from "./AmpAuth.vue?vue&type=script&lang=js&"
import style0 from "./AmpAuth.vue?vue&type=style&index=0&id=a8c2b6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c2b6f4",
  null
  
)

export default component.exports